import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "com-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
    return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      key: index,
      type: item.type === undefined ? 'primary' : item.type,
      size: item.size,
      icon: item.icon,
      round: item.round,
      loading: item.loading,
      onClick: item.click
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
      _: 2
    }, 1032, ["type", "size", "icon", "round", "loading", "onClick"])), [[_vShow, !(item.hidden === true)]]);
  }), 128))]);
}